import React from "react";
import Reveal from "./Reveal";
import styles from "./SectionIntro.module.css";

/**
 * Numbered section masthead: mono index, hairline, label, then the
 * serif display line and an optional lede.
 */
const SectionIntro = ({ index, label, title, lede, children }) => (
  <Reveal as="header" className={styles.intro}>
    <div className={styles.eyebrow}>
      <span className={styles.index}>{index}</span>
      <span className={styles.rule} aria-hidden="true" />
      <span className={styles.label}>{label}</span>
    </div>

    {title && <h2 className={styles.title}>{title}</h2>}
    {lede && <p className={styles.lede}>{lede}</p>}
    {children && <div className={styles.extra}>{children}</div>}
  </Reveal>
);

export default SectionIntro;